import { render, staticRenderFns } from "./ShopProduct.vue?vue&type=template&id=f36d7b68&"
import script from "./ShopProduct.vue?vue&type=script&lang=js&"
export * from "./ShopProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports